import { get } from 'lodash';
import { useClient } from '../context/InteractionsContext';
import { useFind, usePopulate } from './APIHooks';

export const useInteractions = ({ pageNumber, pageSize }) => {
  const client = useClient();

  const { data, isLoading: isInteractionsLoading } = useFind(
    'interaction',
    { person: client.id },
    {
      page: { number: pageNumber, size: pageSize },
      queryConfig: {
        placeholderData: undefined,
        refetchOnWindowFocus: false,
      },
    },
  );

  const interactions = get(data, 'data.data', []);

  const { isLoading: isRecordedByLoading } = usePopulate(
    'recorded_by',
    'employee',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );
  const { isLoading: isPerformingOrgLoading } = usePopulate(
    'performing_org',
    'provider',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );
  const { isLoading: isTypeConceptLoading } = usePopulate(
    'type_concept',
    'concept',
    interactions,
    { queryConfig: { placeholderData: undefined } },
  );

  const isLoading = isInteractionsLoading ||
    isRecordedByLoading ||
    isPerformingOrgLoading ||
    isTypeConceptLoading;

  return { interactions, data, isLoading };
};
